import React from 'react';
import PropTypes from 'prop-types';
import RadioButtonGroup from '@ott/radio-button-group';
import noop from 'lodash/noop';

import cls from 'classnames/bind';
import s from './DatepickerHeader.scss';

const cx = cls.bind(s);

class DatepickerHeader extends React.PureComponent {
  static propTypes = {
    onOptionSelect: PropTypes.func,
    options: PropTypes.array,
    defaultOptionIndex: PropTypes.number,
  };

  static defaultProps = {
    onOptionSelect: noop,
    options: [],
    defaultOptionIndex: 0,
  };

  render() {
    const { onOptionSelect, children, defaultOptionIndex, options } = this.props;

    if (!options.length) {
      return children;
    }

    return (
      <div>
        <RadioButtonGroup
          className={cx('nowrap')}
          optionClassName={cx('option')}
          optionSelectedClassName={cx('option--selected')}
          stretched
          options={options}
          defaultIndex={defaultOptionIndex}
          onChange={onOptionSelect}
        />
        {children}
      </div>
    );
  }
}

export default DatepickerHeader;
